// src/Layout.tsx
import React, { useState } from "react";
import Sidebar from "./Sidebar";
import { Menu } from "lucide-react";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="App">
    
    <div className="sticky-header-container">
        <div className="hamburger-icon" onClick={() => setSidebarOpen(true)}>
          {!sidebarOpen && <Menu color="white" size={24} />}
        </div>
      </div>

      {sidebarOpen && <div className="sidebar-backdrop" />}
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
     

 
      <div >{children}</div>
    </div>
  );
};

export default Layout;
